import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyncProcessorService } from '@vending/sync-engine-client';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { ScrappingTypeModel } from 'src/app/models/scrapping_type';
import { ErrorService } from 'src/packages/mitsBasics';
import { EventsService } from 'src/packages/mitsBasics';
import { OfflineDataService } from 'src/packages/mitsBasics';

@Injectable({
  providedIn: 'root',
})
export class ScrappingTypeService extends OfflineDataService<ScrappingTypeModel> {
  constructor(
    public indexedDBService: NgxIndexedDBService,
    public syncProcessor: SyncProcessorService,
    public http: HttpClient,
    public errorService: ErrorService,
    public events: EventsService
  ) {
    super(
      indexedDBService,
      syncProcessor,
      'Orders::ScrappingType',
      http,
      errorService,
      events,
      'orders/scrapping_types/',
      'orders_scrapping_type',
      ['created_at', 'updated_at', 'created_by_id'],
      []
    );
  }
}
